var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{ref:"chart",staticClass:"chart-pie"})])
}
var staticRenderFns = []

export { render, staticRenderFns }